export function stripFunnelPrefix(path: string, prefix: string): string {
  if (!prefix || !path.startsWith(prefix)) {
    return path;
  }

  return path.slice(prefix.length) || '/';
}
